import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../context/WithConsumer';


export default class ModImage extends Component {
    render () {
	    let block = this.props.block;
	    return (
	        <div className={'l-block l-block--display-' + block.display} style={{backgroundColor: block.block_color}}>
	        	<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
		        	<div className="l-grid">
			        	<div className="l-grid__col">
				        	<div className="c-image" style={{paddingTop: ((block.img_height / block.img_width) * 100) + '%'}}>
				        		<FadeIn className="c-page-header__image c-page-header__image--landscape" duration={250}>
									{onload => (
										<img
											alt={block.img_alt} 
											src={block.img_src} 
											srcSet={block.img_srcset} 
											onLoad={onload}
										/>
									)}
								</FadeIn>
				        	</div>
			        	</div>
			        </div>
		        </ScrollAnimation>
			</div>
		)
	};

};
